import Flickity from 'flickity-imagesloaded';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Cookies from 'js-cookie';
import MicroModal from 'micromodal';
import Plyr from 'plyr';

import {SplitText} from './lib/gsap-plugins/SplitText';


window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;

window.Flickity = Flickity;
window.Plyr = Plyr;
window.Cookies = Cookies;
window.MicroModal = MicroModal;
